import {Button, Col, message, Modal, Row, Table, Upload, UploadProps} from "antd";
import {SquareTile} from "../../components/home/squareTile/SquareTile";
import {IconHome} from "../../const/IconHome.const";
import "./Home.css"
import {useNavigate} from "react-router-dom";
import {AuthService} from "../../services/Auth.service";
import {HttpService} from "../../services/http/Http.service";
import React, {useEffect, useState} from "react";
import {ImportError, RoutingURL, SquareTileTitle} from "../../model/models";
import CustomSpinner from "../../components/spinner/CustomSpinner";
import {HttpErrorService} from "../../services/http/HttpError.service";
import {RiseOutlined} from "@ant-design/icons";
import {ColumnsType} from "antd/es/table";
import {useProgressContext} from "../../services/ProgressContext";

export function Home() {
    const navigate = useNavigate();
    const [uploading, setUploading] = useState(false);
    const [dueTodayCount, setDueTodayCount] = useState<number>(0);
    const [importErrors, setImportErrors] = useState<ImportError[]>()
    const [errorModal, setErrorModal] = useState<boolean>(false)
    const {startPolling} = useProgressContext();

    const columns: ColumnsType<ImportError> = [
        {
            title: 'Riga',
            dataIndex: 'row',
            key: 'row',
            width: 100,
        },
        {
            title: 'Errore',
            dataIndex: 'error',
            key: 'error',
            onCell: () => ({style: {wordBreak: 'break-word', whiteSpace: 'pre-wrap'}}),
        },
    ];

    const fileTsUploadProps = (consideraSanzione?: boolean): UploadProps => ({
        name: 'file',
        showUploadList: false,
        accept: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        customRequest: async (options) => {
            const {file} = options;

            setUploading(true);

            const formData = new FormData();
            formData.append('file', file);

            try {
                const res = await HttpService.getInstanceAxios().post('/file-ts/upload', formData, {
                    headers: {'Content-Type': 'multipart/form-data',},
                    params: consideraSanzione === undefined ? undefined : {consideraSanzione},
                })
                if (!res.data.success) {
                    setImportErrors(res.data.errors)
                    setErrorModal(true)
                    return;
                } else {
                    startPolling(res.data.progressKey,
                        () => {
                            message.success(`File caricato con successo`)
                        },
                        () => {
                            message.error(`Errore durante il caricamento del file`)
                        }
                    );
                }

            } catch (error) {
                HttpErrorService.handle(`Errore durante il caricamento del file`, error, true)
            } finally {
                setUploading(false);
            }
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
        },
    });

    const props: UploadProps = fileTsUploadProps();
    const condonoProps: UploadProps = fileTsUploadProps(false);

    const autoCertprops: UploadProps = {
        name: 'file',
        showUploadList: false,
        accept: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        customRequest: async (options) => {
            const {file} = options;

            setUploading(true);

            const formData = new FormData();
            formData.append('file', file);

            try {
                await HttpService.getInstanceAxios().post('/file-ts/uploadAutoCertificazioni', formData, {
                    headers: {'Content-Type': 'multipart/form-data',}
                })
                message.success(`File caricato con successo`);
            } catch (error) {
                HttpErrorService.handle("Errore durante il caricamento del file", error, true)
            } finally {
                setUploading(false);
            }
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
        },
    };

    const cercProps: UploadProps = {
        name: 'file',
        showUploadList: false,
        accept: 'application/zip',
        customRequest: async (options) => {
            const {file} = options as any;
            setUploading(true);

            const formData = new FormData();
            formData.append('file', file);

            try {
                await HttpService.getInstanceAxios().post('/cerc/upload', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                });
                message.success('File CERC caricato ed estratto con successo');
            } catch (error) {
                HttpErrorService.handle('Errore durante il caricamento del file CERC', error, true);
            } finally {
                setUploading(false);
            }
        }
    };

    function goToDesktop() {
        navigate(RoutingURL.SCRIVANIA)
    }

    function goToDossier() {
        navigate(RoutingURL.DOSSIER)
    }

    function goToSettings() {
        navigate(RoutingURL.SETTINGS)
    }

    function goToCruscotto() {
        navigate(RoutingURL.CRUSCOTTO)
    }

    function goToActivity() {
        navigate(RoutingURL.ACTIVITY)
    }


    useEffect(() => {
        HttpService.getInstanceAxios()
            .get('/activity/scadenza-count')
            .then(res => setDueTodayCount(res.data))
            .catch(error => {
                console.error('Errore nel recupero del count delle scadenze:', error);
                setDueTodayCount(0);
            });
    }, []);


    return (
        <>
            <Row gutter={[16, 16]} justify="center" className="home-container">
                {!AuthService.isStandardUser() && (
                    <Col span={10}>
                        <SquareTile
                            description="Interfaccia dedicata alla lavorazione delle pratiche importate."
                            icon={IconHome.SCRIVANIA}
                            onCLick={goToDesktop}
                            title={SquareTileTitle.SCRIVANIA}
                        />
                    </Col>
                )}
                <Col span={10}>
                    <SquareTile
                        description="Elenco completo degli utenti, per la gestione delle pratiche e  l’intervento manuale da parte del dipendente."
                        icon={IconHome.SEARCH}
                        onCLick={goToDossier}
                        title={SquareTileTitle.FASCICOLO}
                    />
                </Col>
                <Col span={10}>
                    <SquareTile
                        description="Elenco delle pratiche associate ai diversi stati, possibilità di produrre report."
                        icon={IconHome.CRUSCOTTO}
                        onCLick={goToCruscotto}
                        title={SquareTileTitle.CRUSCOTTO}
                    />
                </Col>
                <Col span={10}>
                    <SquareTile
                        description="Elenco delle attività da completare."
                        icon={IconHome.ACTIVITY}
                        onCLick={goToActivity}
                        title={SquareTileTitle.ATTIVITA}
                        count={dueTodayCount}
                    />
                </Col>
                <Col span={10}>
                    <SquareTile
                        title="Report"
                        description="Contiene i report generabili."
                        icon={<RiseOutlined/>}
                        onCLick={() => navigate(RoutingURL.REPORT)}
                    />
                </Col>
                {AuthService.isAdmin() && (
                    <Col span={10}>
                        <SquareTile
                            description="Utilizzata per svolgere attività di configurazione e gestione del sistema."
                            icon={IconHome.SETTINGS}
                            onCLick={goToSettings}
                            title={SquareTileTitle.AMMINISTRAZIONE}
                        />
                    </Col>
                )}
            </Row>
            {AuthService.isAdmin() &&
                <>
                    <div className={"home-button-container"}>
                        <Upload {...props}>
                            <Button className={"custom-label-color"} type="primary" icon={IconHome.UPLOAD}>
                                Importa File TS
                            </Button>
                        </Upload>
                    </div>
                    <div className={"home-button-container"}>
                        <Upload {...condonoProps}>
                            <Button className={"custom-label-color"} type="primary" icon={IconHome.UPLOAD}>
                                Importa File TS con condono
                            </Button>
                        </Upload>
                    </div>
                    <div className={"home-button-container"}>
                        <Upload {...autoCertprops}>
                            <Button className={"custom-label-color"} type="primary" icon={IconHome.UPLOAD}>
                                Importa File Autocertificazioni
                            </Button>
                        </Upload>
                    </div>
                    <div className={"home-button-container"}>
                        <Upload {...cercProps}>
                            <Button className={"custom-label-color"} type="primary" icon={IconHome.UPLOAD}>
                                Importa File CERC
                            </Button>
                        </Upload>
                    </div>
                </>
            }
            <CustomSpinner
                message={"Caricamento in corso..."}
                open={uploading}
            />
            <Modal
                open={errorModal}
                title="Errori di validazione del file"
                onCancel={() => setErrorModal(false)}
                footer={null}
                width={800}
                destroyOnClose
            >
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={importErrors}
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                    }}
                    size="middle"
                />
            </Modal>

        </>
    )
}